import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { DatasourceService } from '@app/core/services';
import { State, FilterDescriptor } from '@progress/kendo-data-query';


@Component({
  selector: 'dynamic-dropdownlist',
  template: `
  <!--<div class="example-config">
        Selected Item: {{selectedItem | json}}
    </div>-->
    <kendo-dropdownlist [style.width.%]="100" style="margin-top: 7px;"
        [data]="_list"
        [textField]="textField"
        [valueField]="valueField"
        [defaultItem]="selectedItem"
        [valuePrimitive]="true"        
        [filterable]="true"        
        (valueChange)="valueChange($event)"      
        (filterChange)="filterChange($event)"
    >
    </kendo-dropdownlist>`,
    providers:  [ 
      DatasourceService, 
      {
        provide: NG_VALUE_ACCESSOR,
        multi:true,
        useExisting: DynamicDropdownlistComponent
      }, 
      {
        provide: NG_VALIDATORS,
        multi: true,
        useExisting: DynamicDropdownlistComponent
        
      }
    ]  
})
export class DynamicDropdownlistComponent implements ControlValueAccessor, Validator {  

  //Input: table
  protected _table : string = '__TABLE__';

  @Input()
  set table(value: string) {
    this._table = (value && value.trim());
    // this.debug('set table = ' + this._table);
  }

  get table(): string { return this._table; }

  //Input: valueField
  protected _valueField : string = '__ID__';

  @Input()
  set valueField(value: string) {
    this._valueField = (value && value.trim());
    // this.debug('set valueField = ' + this._valueField);
  }

  get valueField(): string { return this._valueField; }

  //Input: textField
  protected _textField : string = '__NAME__';

  @Input()
  set textField(value: string) {
    this._textField = (value && value.trim());
    // this.debug('set textField = ' + this._textField);
  }

  get textField(): string { return this._textField; }

  //Input: sortField
  protected _sortField : string = 'asc';

  @Input()
  set sortField(value: string) {
    this._sortField = (value && value.trim());
    // this.debug('set sortField = ' + this._sortField);
  }

  get sortField(): string { return this._sortField; }

  //Input: showAll
  protected _showAll: boolean = false;

  @Input()
  set showAll(value: boolean) {
    this._showAll = value;
    // this.debug('set showAll = ' + this._showAll);
  }

  get showAll(): boolean { return this._showAll; }

  //Input: extraFilter
  // private _extraFilter: FilterDescriptor[] = [];;

  // @Input()
  // set extraFilter(value: FilterDescriptor[]) {
  //   this._extraFilter = value;
  //   // this.debug('set showAll = ' + this._showAll);
  // }

  // get extraFilter(): FilterDescriptor[] { return this._extraFilter; }

  @Input() extraFilter : FilterDescriptor[] = [];

  //Input: selectedValue
  protected _selectedValue : number = 0;

  @Input()
  set selectedValue(value: number) {
    this._selectedValue = value;
    // this.debug('set selectedValue = ' + this._selectedValue);
  }

  get selectedValue(): number { return this._selectedValue; }

  //Input: log
  protected _log : boolean = false;

  @Input()
  set log(value: boolean) {
    this._log = value;
    this.debug('set log = ' + this._log);
  }

  get log(): boolean { return this._log; }

  protected debug(...params: any) { 
    if(this._log){
      console.log(this.constructor.name, params);
    } 
  }

  protected _filter: string = ''; 

  protected _list: Array<any> = [];

  protected selectedItem: any;

  //@Override
  protected touched = false;

  //@Override
  protected disabled = false;

  @Output() selected = new EventEmitter<any>();
  
  constructor(protected service: DatasourceService) {
      
  }

  protected getState(): State {
    let state: State = {
      // skip: 0, 
      take: (this._showAll) ? 0: 10, 
      sort: [
        {field: this._textField, dir: (this._sortField == 'asc') ? 'asc': 'desc'}
      ], 
      filter: {
        logic: "and",
        filters: []
      }, 
      //group: []
    }
    if(this.extraFilter != []){
      this.extraFilter.forEach(function(filter){
        state.filter.filters.push(filter);
      })
    }
    if(this._filter != ''){
      let filter: FilterDescriptor = {
        field: this._textField,
        operator: 'contains',
        value: this._filter
      }
      state.filter.filters.push(filter);
    }
    return state;
  };

  protected tryReadData(value: any) : void {
    this.selectedItem = null;
    this.debug('FETCHING: TABLE[ ' + this._table + ' ] -> valueField: ' + this._valueField + ', textField: ' + this._textField + ', sortField: ' + this._sortField + ', showAll: ' + this._showAll);
    this.service.getAll(this._table, this.getState(), (table, res)=>{
      this._list = res.data;
      this.valueChange(value);
    });
  }

  public valueChange(value: any): void {    
    this.markAsTouched();
    if (!this.disabled) {      
      if(value == 0 && this._list.length){
        //Fisrt Element}
        this._selectedValue = this._list[0][this._valueField];
        this.selectedItem = this._list[0];
        this.debug('Method: valueChange = ' + this._selectedValue);
        this.onChange(this._selectedValue);

        //Emitir evento: selected
        this.selected.emit({value: this._selectedValue, item: this.selectedItem});
      }
      else if(this._list.length == 0){
        //No hay elementos
        this._selectedValue = 0;
        this.selectedItem = null;
        this.debug('Method: valueChange = ' + this._selectedValue);
        this.onChange(this._selectedValue);

        //Emitir evento: selected
        this.selected.emit({value: this._selectedValue, item: this.selectedItem});
      }
      else {
        this._selectedValue = value;
        for (let i = 0;  i < this._list.length; i++) {
          if(this._selectedValue == this._list[i][this._valueField])
            this.selectedItem = this._list[i];
        }
        this.debug('Method: valueChange = ' + this._selectedValue);
        this.onChange(this._selectedValue);

        //Emitir evento: selected
        this.selected.emit({value: this._selectedValue, item: this.selectedItem});
      }
    }
  }

  public updateExtraField(value: FilterDescriptor[], selected: any) {

    this.extraFilter = value;
    this.tryReadData(selected);
    console.log('SELECTED EXTRA FIELD:', selected);

  }

  public filterChange(filter: any): void {
    this.debug('Method: filterChange = ' + filter);
    this._filter = filter;    
    this.debug('FETCHING: TABLE[ ' + this._table + ' ] -> valueField: ' + this._valueField + ', textField: ' + this._textField + ', sortField: ' + this._sortField + ', showAll: ' + this._showAll + ', filter: ' + this._filter)
    this.service.getAll(this._table, this.getState(), (table, res)=>{
      this._list = res.data;
    });
  }

  //@Override
  protected onChange = (value) => {};

  //@Override
  protected onTouched = () => {};

  //@Override
  public writeValue(value: number) {
    this.debug('set writeValue = ' + value);
    // if(this._selectedValue != value)
      this.tryReadData(value);
  }

  //@Override
  public registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  //@Override
  public registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  //@Override
  protected markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  //@Override
  public setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  //@Override
  public validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value == 0) {
      return {
        required: {
          value: true
        }
      };
    }
  }

}
